import React from 'react';
import { ThermometerIcon, HeartPulseIcon, ShieldCheckIcon, SmileIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { TrustBadges } from './ui/TrustBadges';
export function BenefitsSection() {
  const benefits = [{
    icon: <ThermometerIcon className="w-10 h-10 text-blue-600" data-id="element-16" />,
    title: 'Terapia de Calor',
    desc: 'Calor profundo que alivia el dolor y relaja los músculos tensos.'
  }, {
    icon: <HeartPulseIcon className="w-10 h-10 text-blue-600" data-id="element-17" />,
    title: 'Mejora la Circulación',
    desc: 'Aumenta el flujo sanguíneo para una recuperación más rápida.'
  }, {
    icon: <ShieldCheckIcon className="w-10 h-10 text-blue-600" data-id="element-18" />,
    title: 'Soporte para Rodilla',
    desc: 'Estabiliza y protege la articulación durante el movimiento.'
  }, {
    icon: <SmileIcon className="w-10 h-10 text-blue-600" data-id="element-19" />,
    title: 'Uso Cómodo',
    desc: 'Diseño ligero y transpirable ideal para uso diario prolongado.'
  }];
  return <section className="w-full bg-slate-50 py-16 px-4 border-y border-slate-200" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-23">
            Beneficios Principales
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-24">
          {benefits.map((benefit, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center hover:shadow-md transition-shadow" data-id="element-25">
              <div className="bg-blue-50 w-20 h-20 mx-auto rounded-full flex items-center justify-center mb-6" data-id="element-26">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-27">
                {benefit.title}
              </h3>
              <p className="text-slate-600" data-id="element-28">{benefit.desc}</p>
            </div>)}
        </div>

        <div className="mt-12 max-w-md mx-auto" data-id="element-29">
          <CTAButton text="Ordenar Ahora – Pago Contra Entrega" data-id="element-30" />
          <TrustBadges className="mt-4" data-id="element-31" />
        </div>
      </div>
    </section>;
}